<script>
import { API_USER } from '../../common/api'
import VillageSelect from '../../components/VillageSelect'

export default {
  name: 'UserAdd',
  data () {
    return {
      userForm: {
        name: '',
        mobile: '',
        village_id: 0,
        house: '',
        now_amount: 0,
        balance: 0,
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        house: [
          { required: true, message: '门牌号不能为空', trigger: 'blur' }
        ],
        village_id: [
          { required: true, message: '所属小区不能为空', trigger: 'blur' }
        ],
        now_amount: [
          { required: true, message: '表单数不能为空', trigger: 'blur' }
        ],
        balance: [
          { required: true, message: '账户余额不能为空', trigger: 'blur' }
        ],
      },
      selectVillageId: 0
    }
  },
  methods: {
    addUser (formName) {
      if (this.userForm.village_id == 0) {
        this.$message.error('请选择小区')
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = this.userForm;
          this.$http.POST(API_USER, params,
          res => {
            this.loading = false;
            this.$emit('addUserSuccess')
          }, err => {
            this.loading = false;
            this.$message.error(err.msg)
          })
        }
      });
    },
    selectVillage (data) {
      this.userForm.village_id = data
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  components: {
    VillageSelect
  }
}
</script>

<template>
  <div class="table_container">
    <el-form ref="userForm" :model="userForm" :rules="rules" size="small" @submit.native.prevent label-width="100px">
      <el-form-item label="用户名" prop="name">
        <el-input v-model="userForm.name" placeholder="请输入用户名" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="userForm.mobile" placeholder="请输入手机号" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="所属小区" prop="village_id">
        <VillageSelect @selectVillageId='selectVillage' style="width: 350px"></VillageSelect>
      </el-form-item>
      <el-form-item label="门牌号" prop="house">
        <el-input v-model="userForm.house" placeholder="请输入门牌号" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="表单数" prop="now_amount">
        <el-input type="number" v-model="userForm.now_amount" placeholder="请输入表单数" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="账户余额" prop="balance">
        <el-input type="number" v-model="userForm.balance" placeholder="请输入账户余额" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="userForm.remark" placeholder="备注" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="resetForm('userForm')" size="small">重 置</el-button>
        <el-button type="primary" @click="addUser('userForm')" size="small">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

@import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/user/UserAdd.vue